<template>
  <footer>
    <div
      class="
        container-fluid
        d-flex
        justify-content-center
        align-items-center
        h-100
      "
    >
      <div
        class="
          footer-fill
          d-flex
          justify-content-center
          align-items-center
          h-100
        "
      >
      <a href="https://vibe-lab.org/">
        <img
          class="logo img-fluid"
          src="@/assets/img/vibelab-logo.png"
          alt=""
        /></a>
      </div>
    </div>
  </footer>
</template>
<style scoped>
.footer-fill {
 z-index:3;
  height: 100%;
  width: 100%;
}
.logo {
  width: 7rem;
}
footer {
  z-index: 1;
  margin-top: auto;
  height: 6rem;
  background: #201f1d;
  position: relative;
  border-top: 1px solid #e8fcd4;
}

</style>